export const MIN_ADULTS = 1
export const MAX_CHILDREN = 6
export const MAX_PASSENGER = 8
